import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ResponsiveDirective } from '@prlw/libs/responsive/responsive.directive';

export type TLegendItem = {
  label: string;
  index: number;
  color?: string;
  checked: boolean;
};

export type TLegendItemAppearance =
  | 'rounded-border'
  | 'rounded-border-grey'
  | 'grey-rect';

@Component({
  selector: 'prlw-legend-button',
  templateUrl: './legend-button.component.html',
  styleUrls: ['./legend-button.component.scss'],
  standalone: true,
  imports: [CommonModule, ResponsiveDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegendButtonComponent {
  @Input() item: TLegendItem = {
    label: 'label',
    index: 0,
    checked: false,
  };
  @Input() appearance: TLegendItemAppearance | null = null;
  @Input() showArrow: boolean | null = false;
  @Output() eventClick = new EventEmitter<TLegendItem>();

  handleClick() {
    this.eventClick.emit({
      ...this.item,
      checked: !this.item.checked,
    });
  }

  getAppearanceClassName() {
    return `${this.appearance ?? 'rounded-border'}-appearance`;
  }
}
